import type { DocMigration } from "../docMigration";

const MIN_BALUSTER_WIDTH_INCHES = 0.25;

function clampBalusterValues(setting: any) {
  if (!setting || typeof setting !== "object") {
    return;
  }

  if (typeof setting.baluster?.width === "number" && setting.baluster.width < MIN_BALUSTER_WIDTH_INCHES) {
    setting.baluster.width = MIN_BALUSTER_WIDTH_INCHES;
  }

  if (typeof setting.balusterSpacing === "number" && setting.balusterSpacing < MIN_BALUSTER_WIDTH_INCHES) {
    setting.balusterSpacing = MIN_BALUSTER_WIDTH_INCHES;
  }
}

const migration: DocMigration = {
  id: "20260218_baluster_min_width",
  description: "Clamp baluster width and spacing to 1/4 inch minimum",
  apply(json: any): any {
    const settingsTable = json.settings ?? {};
    for (const settingSet of Object.values(settingsTable)) {
      const setting = settingSet as { type?: string; railingSettingsTable?: Record<string, any> };
      if (setting.type !== "RAILING_CATALOG_SETTINGS") {
        continue;
      }

      const railingSettingsTable = setting.railingSettingsTable ?? {};
      for (const railingSetting of Object.values(railingSettingsTable)) {
        clampBalusterValues(railingSetting);
      }
    }

    const railings = json.railings ?? {};
    for (const railing of Object.values(railings)) {
      const settingsOverride = (railing as { settingsOverride?: any }).settingsOverride;
      if (!settingsOverride || typeof settingsOverride !== "object") {
        continue;
      }
      clampBalusterValues(settingsOverride);
    }

    return json;
  },
};

export default migration;
